import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {_SettingsService} from "../../../services/settings.service";
import {_GridService} from "../../../ng1-services/grid.service";
import {jqxGridComponent} from "../../../../assets/jqwidgets-ts/angular_jqxgrid";
import {Grid} from "../../../interfaces/grid.interface";
import {Observable} from "rxjs/Observable";

declare var $: any, dump: any;

@Component({
  selector: 'minimum-order-quantity',
  templateUrl: './minimum-order-quantity.component.html',
  styleUrls: ['./minimum-order-quantity.component.css'],
})

export class MinimumOrderQuantityBranch implements OnInit, OnDestroy {

  private $observable: Observable<any>;
  private subscription: any;

  @ViewChild('minimumOrderQuantityGrid') minimumOrderQuantityGrid: jqxGridComponent;
  private minimumOrderQuantitySettings: Grid;

  constructor (private titleService: Title, private settingService: _SettingsService, private gridservice: _GridService) {}

  ngOnInit(){
    this.titleService.setTitle("WiseRisk | Minimum Order Quantity Settings");
    this.getMinimumOrderQuantities();
  }

  getMinimumOrderQuantities(){
    this.minimumOrderQuantitySettings = null;
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    this.$observable = this.settingService.GetMinimumOrderQuantities();
    this.subscription = this.$observable.subscribe(
      result => this.loadMinimumOrderQuantities(result)
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  loadMinimumOrderQuantities(minimumOrderQuantities) {
    let msgContainer = "minimumOrderQuantityMsg";
    var source = {
      datatype: 'json',
      localdata: minimumOrderQuantities,
      datafields: [
        {
          name: 'minimumOrderQuantityId',
          type: 'string'
        }, {
          name: 'organizationId',
          type: 'string'
        }, {
          name: 'quantity',
          type: 'string'
        }, {
          name: 'currency',
          type: 'string'
        }
      ],
      updaterow: (rowid, rowdata, commit) => {
        if (rowdata.rowId < 1) {
          this.settingService.CreateMinimumOrderQuantity(rowdata).subscribe(data => {
            this.gridservice.SuccessMsg(msgContainer, 'Minimum Order Quantity Added');
            this.getMinimumOrderQuantities();
          }, data => {
            this.gridservice.ErrorMsg(msgContainer, data);
          });
        } else {
          this.settingService.UpdateMinimumOrderQuantity(rowdata).subscribe(data => {
            this.gridservice.SuccessMsg(msgContainer, 'Minimum Order Quantity Updated');
            this.getMinimumOrderQuantities();
          }, data => {
            this.gridservice.ErrorMsg(msgContainer, data);
          });
        }
      },
      deleterow: (rowdata) => {
        this.settingService.DeleteMinimumOrderQuantity(rowdata.minimumOrderQuantityId).subscribe(data => {
          this.gridservice.SuccessMsg(msgContainer, 'Minimum Order Quantity Deleted');
          this.getMinimumOrderQuantities();
        }, data => {
          this.gridservice.ErrorMsg(msgContainer, data);
        });
      },
      refresh: () => {
        this.getMinimumOrderQuantities();
      },
      getGrid: () => {
        return this.minimumOrderQuantityGrid;
      }
    };
    this.minimumOrderQuantitySettings = {
      source: source,
      dataAdapter: new $.jqx.dataAdapter(source),
      columns: [
        {
          text : 'Currency of Quantity',
          columntype : 'dropdownlist',
          datafield : 'currency',
          width : '150',
          createeditor : (row, cellvalue, editor) => {
            editor.jqxDropDownList({
              source : this.gridservice.GetCurrencyDataAdapter(false, false),
              displayMember : "currency",
              valueMember : "currency"
            });
          }
        }, {
          text: 'Minimum Quantity',
          columntype: 'textbox',
          datafield: 'quantity'
        }
      ],
      renderstatusbar: (statusbar: any) => {
        this.gridservice.RenderStatusBar(statusbar, source);
      }
    };
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/settings/minimum-order-quantity/minimum-order-quantity.component.ts